import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { i18, trb, translationGroups } from "@utilities";
import { KYCActions, selectIsAppDocsUploading } from "@redux";
import { DOCUMENT_FLAG_OPTIONS, COMMENT_REQUIRED, FILE_REQUIRED } from "@config";

export const RequestedDocsListItem = ({
  applicationDocumentId,
  fileOptions,
  goToDocApprovalState
}) => {
  const dispatch = useDispatch();
  const isUploading = useSelector(selectIsAppDocsUploading);
  const [files, setFiles] = useState([]);
  const [comment, setComment] = useState("");

  const isUploadBtnDisabled = useMemo(() => {
    if (
      (FILE_REQUIRED.includes(fileOptions) && !files.length) ||
      (COMMENT_REQUIRED.includes(fileOptions) && !comment)
    ) {
      return true;
    }
    return false;
  }, [fileOptions, files, comment]);

  const removeFileFromList = file => {
    const newFileList = [...files];
    const index = newFileList.indexOf(file);
    newFileList.splice(index, 1);
    setFiles(newFileList);
  };

  const addFileToList = file => {
    if (applicationDocumentId) {
      file.applicationId = applicationDocumentId;
    }
    setFiles([...files, file]);
    return false;
  };

  const onUpload = async () => {
    const formData = new FormData();
    files.forEach(item => {
      formData.append("files", item);
    });
    if (comment) {
      formData.append("comment", comment);
    }
    try {
      const response = await dispatch(
        KYCActions.uploadApplicationDocument(formData, applicationDocumentId)
      );
      setFiles([]);
      setComment("");
      // move to pending if doc uploading is finished
      if (response.payload.applicationDocumentsList.length === 0) {
        goToDocApprovalState();
      }
    } catch (e) { }
  };

  return (
    <>
      <p className="my-3">{trb(i18.ApplicationsLabels[fileOptions])}</p>
      {fileOptions !== DOCUMENT_FLAG_OPTIONS.MANDATORY_COMMENT && (
        <Upload.Dragger
          beforeUpload={file => addFileToList(file)}
          onRemove={removeFileFromList}
          className="mb-5 py-3"
          accept=".pdf,.jpg,.png,.bmp,.jpeg"
          multiple
          fileList={files}
        >
          <div className="eb_content_subtitle text-center mx-1">
            {trb(translationGroups.ActionsTitle + "UploadApplicationDocument")}
          </div>
          <p className="ant-upload-drag-icon">
            <PlusOutlined />
          </p>
        </Upload.Dragger>
      )}
      {fileOptions !== DOCUMENT_FLAG_OPTIONS.FILE_WITHOUT_COMMENT && (
        <Input
          value={comment}
          onChange={e => setComment(e.target.value)}
          type="text"
          name="comment"
          size="large"
          placeholder={trb(i18.ApplicationsLabels.Comment)}
          className="mb-4"
        />
      )}
      <div className="w-100 text-right">
        <Button
          type="primary"
          className="btn-big"
          disabled={isUploadBtnDisabled || isUploading}
          loading={isUploading}
          onClick={onUpload}
          size="large"
        >
          {trb(i18.Buttons.Upload)}
        </Button>
      </div>
    </>
  );
};
